import { useState } from 'react';

export function MaintenanceIntervalCard({
  interval,
  defaultExpanded,
}: {
  interval: { mileage?: { miles?: number; km?: number }; service_items?: string[] };
  defaultExpanded: boolean;
}) {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const itemCount = interval.service_items?.length || 0;

  return (
    <div className="bg-obdai-deep rounded-xl overflow-hidden">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full p-4 flex items-center justify-between text-left hover:bg-white/5 transition"
      >
        <div className="flex items-center gap-4">
          <div className="text-purple-400 font-bold">
            {interval.mileage?.miles?.toLocaleString()} mi
          </div>
          {interval.mileage?.km && (
            <div className="text-gray-500 text-sm">
              ({interval.mileage.km.toLocaleString()} km)
            </div>
          )}
          <span className="text-gray-400 text-sm">{itemCount} service items</span>
        </div>
        <svg
          className={`w-5 h-5 text-gray-400 transition-transform ${expanded ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {expanded && (
        <ul className="px-4 pb-4 space-y-1">
          {interval.service_items?.map((item, itemIdx) => (
            <li key={itemIdx} className="text-gray-300 text-sm flex items-start gap-2">
              <span className="text-purple-400">•</span>
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
